<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <div
            class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
            <div class="d-sm-flex align-items-center">
                <router-link 
                    to="/addBescPricingRule"
                    class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
                    >
                    <i class="flaticon-plus position-relative ms-5 fs-12"></i>
                    Ajouter une règle de pricing
                </router-link>
            </div>
            <div class="d-flex align-items-center">
                <form class="search-box position-relative me-15" @submit.prevent="rechercher">
                    <input type="text" name="mot" v-model="searchTerm" @keyup="rechercher"
                        class="form-control shadow-none text-black rounded-0 border-0"
                        placeholder="Rechercher une règle" />
                    <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
                        <i class="flaticon-search-interface-symbol"></i>
                    </button>
                </form>
            </div>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25">
            <div class="table-responsive">
                <table class="table text-nowrap align-middle mb-0">
                    <thead>
                        <tr>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Code
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Nom
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Zone Tarifaire
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Type Entité
                            </th>
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Montant Base
                            </th>
                            <!-- <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Taux %
                            </th> -->
                            <!-- <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Priorité
                            </th> -->
                            <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                                Statut
                            </th>
                            <th scope="col"
                                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                                Actions
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(rule, index) in pricingRules" :key="rule.id || index">
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ rule.code }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ rule.name }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ rule.tariffZone?.code ? `${rule.tariffZone.code} - ${rule.tariffZone.name}` : '-' }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ getEntityTypeLabel(rule.appliesToEntityType) }}
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ rule.baseAmount || rule.perContainerAmount ? `${rule.baseAmount || rule.perContainerAmount} ${rule.amountCurrency || 'EUROS'}` : '-' }}
                            </td>
                            <!-- <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ rule.percentageRate ? `${rule.percentageRate}%` : '-' }}
                            </td> -->
                            <!-- <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                {{ rule.priority }}
                            </td> -->
                            <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                                <span class="badge" :class="rule.isActive ? 'bg-success' : 'bg-danger'">
                                    {{ rule.isActive ? 'Active' : 'Inactive' }}
                                </span>
                                <span v-if="rule.isExemptionRule" class="badge bg-warning text-dark ms-1">
                                    Exemption
                                </span>
                            </td>
                            <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                                <div class="dropdown">
                                    <span class="badge text-white bg-primary fs-15 dropdown-toggle cursor-pointer"
                                        data-bs-toggle="dropdown" aria-expanded="false">
                                        Actions
                                        <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                                    </span>
                                    <ul class="dropdown-menu">
                                        <!-- === VOIR LES DÉTAILS === -->
                                        <li>
                                            <router-link 
                                                :to="{ name: 'ViewBescPricingRulePage', params: { id: rule.id } }"
                                                class="dropdown-item d-flex align-items-center">
                                                <i class="flaticon-view lh-1 me-8 position-relative top-1"></i>
                                                Voir les détails
                                            </router-link>
                                        </li>

                                        <!-- === MODIFIER === -->
                                        <li>
                                            <router-link 
                                                :to="{ name: 'EditBescPricingRulePage', params: { id: rule.id } }"
                                                class="dropdown-item d-flex align-items-center">
                                                <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                                                Modifier
                                            </router-link>
                                        </li>

                                        <!-- === SUPPRIMER === -->
                                        <li>
                                            <a class="dropdown-item d-flex align-items-center text-danger"
                                                href="javascript:void(0);"
                                                @click="suppression(rule.id, pricingRules, 'pricing-rule', 'règle de pricing')">
                                                <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                                                Supprimer
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
                <PaginationComponent 
                    :page="page" 
                    :totalPages="totalPages" 
                    :totalElements="totalElements" 
                    :limit="limit"
                    @paginate="handlePaginate" 
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "../../services/ApiService";
import { suppression, error } from "../../utils/utils";
import PaginationComponent from '../../components/Utilities/Pagination.vue';
import JwtService from "../../services/JwtService";

export default defineComponent({
    name: "ListePricingRule",
    components: {
        PaginationComponent
    },
    setup: () => {
        const pricingRules = ref<Array<any>>([]);
        const searchTerm = ref('');
        const page = ref(1);
        const totalPages = ref(0);
        const limit = ref(10);
        const totalElements = ref(0);

        const entityTypeLabels: Record<string, string> = {
            BESC: 'BESC - Dossier complet',
            BL: 'BL - Connaissement',
            CONTAINER: 'CONTAINER - Conteneur',
            CARGO_LINE: 'CARGO_LINE - Ligne de marchandise',
            GOODS: 'GOODS - Marchandises (par catégorie)',
            VALUE_BRACKET: 'VALUE_BRACKET - Tranche de valeur'
        };

        const getEntityTypeLabel = (type: string) => {
            return entityTypeLabels[type] || type;
        };

        const handlePaginate = ({ page_, limit_ }: { page_: number; limit_: number }) => {
            page.value = page_;
            getAllPricingRules(page_, limit_);
        };

        function rechercher() {
            page.value = 1; // Reset à la première page lors d'une recherche
            getAllPricingRules(page.value, limit.value, searchTerm.value);
        }

        function getAllPricingRules(page = 1, limi = 10, searchTerm = '') {
            return ApiService.get(`/pricing-rules?page=${page}&limit=${limi}&mot=${searchTerm}`)
                .then(({ data }) => {
                    pricingRules.value = data.data.data;
                    totalPages.value = data.data.totalPages;
                    limit.value = data.data.limit;
                    totalElements.value = data.data.totalElements;
                })
                .catch(({ response }) => {
                    error(response?.data?.message || "Erreur lors du chargement des règles");
                });
        }

        onMounted(() => {
            getAllPricingRules();
        });

        const privileges = ref<Array<string>>(JwtService.getPrivilege());

        const checkPermission = (name: string) => {
            return privileges.value.includes(name);
        };

        return {
            checkPermission,
            pricingRules,
            suppression,
            page,
            totalPages,
            limit,
            totalElements,
            getAllPricingRules,
            handlePaginate,
            searchTerm,
            rechercher,
            getEntityTypeLabel
        };
    },
});
</script>